import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { PROMOTION_TYPE } from '../../providers/myria/app-variables';
import { APP_CONFIG } from '../../environment';
import { NumberFormatter, getCurrencyDisplayName } from '../../pipes/currency-pipe';
import { regions } from '../../environment/region/regions';

@Component({
  selector: 'rmt-list-item',
  templateUrl: 'rmt-list-item.html'
})
export class RmtListItemComponent {

  @Input() private title: string;
  @Input() titleStyle: string;
  @Input() private subtitle1: string;
  @Input() private description: string;
  @Input() private rate: number;
  @Input() private promoRate: number;
  @Input() private sendCurrency: string;
  @Input() private receiveCurrency: string;
  @Input() private button: string;
  @Input() private buttonType: string = 'chevron';
  @Input() private img: string;
  @Input() private border: boolean = true;
  @Input() private first: boolean = false;
  @Input() private promo: any;
  @Input() private isPremiumRate: boolean = false;
  @Input() isSelected: boolean = false;
  @Input() useImageContainer: boolean = false;
  @Output() itemEmitter = new EventEmitter();
  @Output() clickButton = new EventEmitter();

  buttonEvent: boolean = false;

  constructor(private currencyFormatter: NumberFormatter) {}

  emit() {
    if(!this.buttonEvent)
      this.itemEmitter.emit('');
    else
      this.buttonEvent = false;
  }

  processClickButton(ev) {
    this.buttonEvent =  true;
    this.clickButton.emit(ev);
  }

  getPriceHint()  {
    if (this.rate) {
       const convertedRate = APP_CONFIG.region === regions.US? this.currencyFormatter.transform(this.rate, null): this.rate;
       return convertedRate + ' ' + getCurrencyDisplayName(this.receiveCurrency);
    }
    return '';

  }


}



// WEBPACK FOOTER //
// ./src/components/rmt-list-item/rmt-list-item.ts